/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import InputBehaviorComponent from 'app/components/EditorComponents/InputBehaviorComponent.jsx';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';

class TwitterInputConfigPanel extends React.Component {
    constructor(props) {
        super(props);

        this.usernameHandler = this.usernameHandler.bind(this);
        this.listHandler = this.listHandler.bind(this);
        this.typeHandler = this.typeHandler.bind(this);

    }

    usernameHandler(e) {
        var nameEvent = {
                currentTarget: {
                    dataset: {
                        field: this.props.statePath + '.name'
                    }
                },
                target: {
                    value: ''
                }
            },
            constants = this.props.app.config.constants,
            list = (this.props.input.attrs && this.props.input.attrs.list_id) ? this.props.input.attrs.list_id : '';

        if (e.target.value !== '' && !e.target.value.match(/^@/)) {
            e.target.value = "@" + e.target.value;
        }

        nameEvent.target.value = e.target.value;
		if (this.props.input.attrs.type == constants.TWITTER_TYPE_USER) {
			nameEvent.target.value += " Timeline";
		} else if (this.props.input.attrs.type == constants.TWITTER_TYPE_MENTIONS) {
			nameEvent.target.value += " Mentions";
		} else if (this.props.input.attrs.type == constants.TWITTER_TYPE_FAVORITES) {
			nameEvent.target.value += " Favorites";
		} else if (this.props.input.attrs.type == constants.TWITTER_TYPE_LIST) {
            nameEvent.target.value = "Twitter List #" + list;
        }

        this.props.changeHandler(e);
        this.props.changeHandler(nameEvent);
    }

    listHandler(e) {

        var constants = this.props.app.config.constants,
            nameEvent = {
                currentTarget: {
                    dataset: {
                        field: this.props.statePath + '.name'
                    }
                },
                target: {
                    value: ''
                }
            },
            list = e.target.value,
            username = (this.props.input.attrs.user_name) ? this.props.input.attrs.user_name : this.props.input.username;

        if (username === undefined) {
            username = '';
        };

        if (username !== '' && !username.match(/^@/)) {
            username = "@" + username;
        }

        if (this.props.input.attrs.type == constants.TWITTER_TYPE_USER) {
            nameEvent.target.value = username + " Timeline";
        } else if (this.props.input.attrs.type == constants.TWITTER_TYPE_MENTIONS) {
            nameEvent.target.value = username + " Mentions";
        } else if (this.props.input.attrs.type == constants.TWITTER_TYPE_FAVORITES) {
            nameEvent.target.value = username + " Favorites";
        } else if (this.props.input.attrs.type == constants.TWITTER_TYPE_LIST) {
            nameEvent.target.value = "Twitter List #" + list;
        }

        this.props.changeHandler(e);
        this.props.changeHandler(nameEvent);

    }

    typeHandler(e) {

        var constants = this.props.app.config.constants,
            nameEvent = {
                currentTarget: {
                    dataset: {
                        field: this.props.statePath + '.name'
                    }
                },
                target: {
                    value: ''
                }
            },
            listEvent = {
                currentTarget: {
                    dataset: {
                        field: this.props.statePath + '.attrs.list_id'
                    }
                },
                target: {
                    value: ''
                }
            },
            list = (this.props.input.attrs && this.props.input.attrs.list_id) ? this.props.input.attrs.list_id : '',
            username = (this.props.input.attrs.user_name) ? this.props.input.attrs.user_name : this.props.input.username;

        if (username === undefined) {
            username = '';
        }

        if (username !== '' && !username.match(/^@/)) {
            username = "@" + username;
        }

        if (e.target.value == constants.TWITTER_TYPE_USER) {
            nameEvent.target.value = username + " Timeline";
            //reset list name if set
            this.props.changeHandler(listEvent);
        } else if (e.target.value == constants.TWITTER_TYPE_MENTIONS) {
            nameEvent.target.value = username + " Mentions";
            this.props.changeHandler(listEvent);
        } else if (e.target.value == constants.TWITTER_TYPE_FAVORITES) {
            nameEvent.target.value = username + " Favorites";
            this.props.changeHandler(listEvent);
        } else if (e.target.value == constants.TWITTER_TYPE_LIST) {
            nameEvent.target.value = username + "/" + list + " List";
            // don't reset the list name... user will enter it
        }

        this.props.changeHandler(e);
        this.props.changeHandler(nameEvent);

    }

    render() {
        let constants = this.props.app.config.constants,
            listComponent = null,
            typeOptions = [
                {value: constants.TWITTER_TYPE_USER, label: 'Timeline'},
                {value: constants.TWITTER_TYPE_LIST, label: 'List (provide id below)'},
                {value: constants.TWITTER_TYPE_FAVORITES, label: 'Favorites'},
            ],
            userId = (this.props.input.attrs && this.props.input.attrs.user_name) ? this.props.input.attrs.user_name : '',
            type = (this.props.input.attrs && this.props.input.attrs.type) ? this.props.input.attrs.type : constants.TWITTER_TYPE_USER,
            listId = (this.props.input.attrs && this.props.input.attrs.list_id) ? this.props.input.attrs.list_id : '',
            behavior = null,
            twitterFields = null;

        if (this.props.input.postFlag === undefined) {
            this.props.input.postFlag = constants.POST_NOW;
            this.props.input.firstPostFlag = constants.FIRSTPULL_SINGLE;
        }

        if (this.props.input.attrs && this.props.input.attrs.type == constants.TWITTER_TYPE_LIST) {
            listComponent = (
                <fieldset>
                    <legend>List ID <span className="required">*</span></legend>
                    <ErrorModule
                        app={this.props.app}
                        keys={['CURATION_INPUT_CREATE', 'INPUT_UPDATE', 'INPUT_CREATE', 'INPUT_VALIDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="attrs.list_id" errors={state.errors}/>
                            );
                        }}/>
                    {"https://twitter.com/i/lists/ "}<UncontrolledTextInput
                            key="list_id"
                            className="text-input small"
                            placeholder="List ID"
                            defaultValue={listId}
                            onChange={this.listHandler}
                            data-field={this.props.statePath + ".attrs.list_id"}/>
                            <HelpButton which="twitterList"/>
                </fieldset>
            );
        }

        if (this.props.routeType != constants.R_CURATE_BASIC && this.props.showBehavior) {
            behavior = (
                <InputBehaviorComponent
                    {...this.props}
                    input={this.props.input}
                    changeHandler={this.props.changeHandler}
                    statePath={this.props.statePath} />
            );
        }

        if (this.props.showTwitterFields) {
            twitterFields = (
                <div>
                    <div className="section-header">
                        Auto share tweets across social media
                    </div>
                    <fieldset>
                        <legend>Account <span className="required">*</span></legend>
                        <ErrorModule
                            app={this.props.app}
                            keys={['CURATION_INPUT_CREATE', 'INPUT_UPDATE', 'INPUT_CREATE', 'INPUT_VALIDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="name" errors={state.errors}/>
                                );
                            }}/>
                        <ErrorModule
                            app={this.props.app}
                            keys={['CURATION_INPUT_CREATE', 'INPUT_UPDATE', 'INPUT_CREATE', 'INPUT_VALIDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="attrs.user_name" errors={state.errors}/>
                                );
                            }}/>
                        <UncontrolledTextInput
                                key="user_name"
                                className="text-input small"
                                placeholder="@awesomeuser"
                                defaultValue={userId}
                                onChange={this.usernameHandler}
                                data-field={this.props.statePath + ".attrs.user_name"}/>
                    </fieldset>
                    <fieldset>
                        <legend>Post Items From</legend>
                        <ErrorModule
                            app={this.props.app}
                            keys={['CURATION_INPUT_CREATE', 'INPUT_UPDATE', 'INPUT_CREATE', 'INPUT_VALIDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="attrs.type" errors={state.errors}/>
                                );
                            }}/>
                        <StyledSelect
                            options={typeOptions}
                            linkedField={this.props.statePath + ".attrs.type"}
                            value={type}
                            selectClass="med"
                            onChange={this.typeHandler} />
                    </fieldset>
                </div>
            );

            // listComponent should not be displayed if showTwitterFields is false
            if (listComponent) {
                twitterFields = (
                    <div>
                    {twitterFields}
                    {listComponent}
                    </div>
                );
            }
        }


        return (
            <div className="editor-panel">
                {twitterFields}
                {behavior}
                {this.props.replayPromo}
            </div>
        );
    }

};

TwitterInputConfigPanel.displayName = "TwitterInputConfigPanel";

TwitterInputConfigPanel.propTypes = {
    showBehavior: PropTypes.bool,
    showTwitterFields: PropTypes.bool
};

TwitterInputConfigPanel.defaultProps = {
    showBehavior: true,
    showTwitterFields: true
};

export default TwitterInputConfigPanel;
